import {updateLabelConfig} from '../../../../data/labelInfos/index.js'
import ConfigSelect from '../ConfigSelect.js'
import {CANADA_POST} from '../../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from '../useLabelProperty.js'

const VALID_SHIPPER_TYPES = [CANADA_POST]

function labelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__service_option`]
    : []
}

export default function ServiceOption() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = ServiceOption.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigSelect
      label="Service Option"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="service_option"
    />
  )
}

ServiceOption.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
